import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes } from './p-198613ef.js';

const biSpinnerCss = ".spinner {\n  width: 1em;\n  height: 1em;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  --color: currentColor;\n  background:\n    radial-gradient(farthest-side, var(--color) 94%, #0000) top/4px 4px no-repeat,\n    conic-gradient(#0000 30%, var(--color));\n  mask: radial-gradient(farthest-side, #0000 calc(100% - 4px), #000 0);\n  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 4px), #000 0);\n  animation: spinner 1s infinite linear;\n\n  &[data-color='inherit'] {\n    --color: currentColor;\n  }\n  &[data-color='black'] {\n    --color: var(--bi-basic-key);\n  }\n\n  &[data-size='2xl'] {\n    font-size: var(--bi-scale-12x);\n  }\n\n  &[data-size='xl'] {\n    font-size: var(--bi-scale-10x);\n  }\n\n  &[data-size='large'] {\n    font-size: var(--bi-scale-8x);\n  }\n\n  &[data-size='medium'] {\n    font-size: var(--bi-scale-6x);\n  }\n\n  &[data-size='small'] {\n    font-size: var(--bi-scale-5x);\n  }\n}\n\n@keyframes spinner {\n  100% {\n    transform: rotate(1turn);\n  }\n}\n";
const BiSpinnerStyle0 = biSpinnerCss;

const BiSpinner = /*@__PURE__*/ proxyCustomElement(class BiSpinner extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        /**
         * The color of the spinner.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
    }
    render() {
        return (h(Host, { key: '119711329f5d08a007544c6e4cafbcaea4ba24d3' }, h("div", { key: '83e3c9e25409cf9badaa19a2648456464ba5150b', class: 'spinner', "data-size": this.size, "data-color": this.color, ...this.inheritedAttributes })));
    }
    get el() { return this; }
    static get style() { return BiSpinnerStyle0; }
}, [1, "bi-spinner", {
        "color": [1],
        "size": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-spinner"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-spinner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiSpinner);
            }
            break;
    } });
}

export { BiSpinner as B, defineCustomElement as d };
